import React, { PropsWithChildren } from 'react';

import { PropsWithClassName } from '@/types';
import { EnumContextGDT } from '@/types/team';
import { cn } from '@/utils';

interface Props extends PropsWithChildren, PropsWithClassName {
  context?: EnumContextGDT;
}

export const Sidebar = React.memo(
  ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    context = EnumContextGDT.FriendTournament,
    children,
    className,
  }: Props) => {
    return <div className={cn('', className)}>{children}</div>;
  }
);

Sidebar.displayName = 'Sidebar';
